import { HiShieldCheck } from "react-icons/hi";
import { MdCancel, MdAnalytics } from "react-icons/md";
const data = [
  {
    icon: <HiShieldCheck/>,
    heading: " Credibility and Legitimacy",
    detail:
      " We ensure that all scholarships and educational opportunities listed on our website are legitimate and credible, providing our users with peace of mind.",
  },
  {
    icon: <MdCancel />,
    heading: "Comprehensive Opportunities:",
    detail:
      " From scholarships to internships, fellowships to grants, we offer a wide range of educational opportunities to help you achieve your academic and career goals.",
  },
  {
    icon: <MdAnalytics />,
    heading: "Accessibility and Convenience",
    detail:
      "Our user-friendly platform makes it easy for you to find and apply for scholarships and educational opportunities that match your interests and qualifications.",
  },
];
export default data;